/**
 * @generated SignedSource<<2b66f972164883417b0bd41278d5d8fc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EventAcceptRulesButtonEventFragment$data = {
  readonly id: string;
  readonly latestRule: {
    readonly entityAgreement: {
      readonly createdAt: DateTime;
      readonly id: string;
    } | null | undefined;
    readonly id: string;
  };
  readonly " $fragmentType": "EventAcceptRulesButtonEventFragment";
};
export type EventAcceptRulesButtonEventFragment$key = {
  readonly " $data"?: EventAcceptRulesButtonEventFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAcceptRulesButtonEventFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAcceptRulesButtonEventFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EventRule",
      "kind": "LinkedField",
      "name": "latestRule",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EventRuleAgreement",
          "kind": "LinkedField",
          "name": "entityAgreement",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "5579ddd8dfd4f38be0573ff5ed6ba753";

export default node;
